import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import config from '../../../../../config';
import { getAuthToken } from '../../../../utils/auth';
import useDidMount from '../../../hooks/use-didMount';

const putPriceSettings = async (articleId, priceSettings) => {
  const accessToken = getAuthToken();

  const payload = priceSettings;

  const response = await fetch(
    `${config.ApiBaseUrl}/article/${articleId}/updatePriceSetting`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    }
  );

  const json = await response.json();

  const { message, success } = json;

  if (!success)
    throw new Error(
      message ?? 'Something went wrong. failed to process request'
    );

  return success;
};

const usePriceSettings = (articleId, price, tipJarPrice, postTitle) => {
  const [priceSettings, setPriceSettings] = useState({
    paywallPrice: price,
    tipJarPrice,
  });

  const [isEdited, setIsEdited] = useState(false);

  useEffect(() => {
    setPriceSettings({
      paywallPrice: price,
      tipJarPrice,
    });
  }, [price, tipJarPrice]);

  const didMount = useDidMount();
  const publisherId = useSelector((state) => state.user.publisher?.id);

  useEffect(() => {
    if (!didMount && isEdited) {
      if (publisherId) {
        toast.promise(putPriceSettings(articleId, priceSettings), {
          loading: `setting ${postTitle} price...`,
          success: `${postTitle} price set!`,
          error: `Error while setting ${postTitle} price!`,
        });
      }
    }
  }, [publisherId, priceSettings, isEdited]);

  const handleTipJarChange = (tipJar) => {
    const tipJarTransformed = [];

    tipJar.forEach((key) => {
      tipJarTransformed.push(tipJar[key]);
    });
    // for (const key in tipJar) {
    //   tipJarTransformed.push(tipJar[key]);
    // }

    setPriceSettings((prevState) => ({
      ...prevState,
      tipJarPrice: tipJarTransformed,
    }));
  };

  const handlePaywallChange = (paywall) => {
    setPriceSettings((prevState) => ({ ...prevState, paywallPrice: paywall }));
  };

  return {
    priceSettings,
    handlePaywallChange,
    handleTipJarChange,
    setIsEdited,
  };
};

export default usePriceSettings;

// const usePriceSettings = (price, tipJarPrice, articleId, article) => {
//   const didMount = useDidMount();

//   const publisherId = useSelector((state) => state.user.publisher?.id);

//   const [priceSettings, setPriceSettings] = useState({
//     paywallPrice: price,
//     tipJarPrice: tipJarPrice,
//   });

//   useEffect(() => {
//     if (!didMount) {
//       if (publisherId) {
//         toast.promise(putPriceSettings(articleId, priceSettings), {
//           loading: `setting ${article} price...`,
//           success: `${article} price set!`,
//           error: `Error while setting ${article} price!`,
//         });
//       }
//     }
//   }, [priceSettings]);

// const handleTipJarChange = (tipJar) => {
//   let tipJarTransformed = [];
//   for (let key in tipJar) {
//     tipJarTransformed.push(tipJar[key]);
//   }
//   setPriceSettings((prevState) => {
//     return {
//       ...prevState,
//       tipJarPrice: tipJarTransformed,
//     };
//   });
// };

// const handlePaywallChange = (paywall) => {
//   console.log("inside paywall change", paywall);
//   setPriceSettings((prevState) => {
//     return { ...prevState, paywallPrice: paywall };
//   });
// };

// return {
//   priceSettings,
//   handlePaywallChange,
//   handleTipJarChange,
// };
// };
